import './css/style.css'

import React, { useState } from "react";
import { useDispatch, useSelector } from "react-redux";

import { registerJobAndWait } from "../../slice";
import CheckAllInterface from './components/CheckAllInterface'
import FontSizeSelect from "./components/FontSizeSelect";
import PrefMunicipalitySelect from './components/PrefMunicipalitySelect';
import SettingInterfacePptx from './components/SettingInterfacePptx'
import WaitWidget from "./components/WaitWidget";
import alplat_logo from './img/alplat_logo.svg'
import bnr_ccca from './img/bnr_ccca.gif'
import bnr_env from './img/bnr_env.gif'
import eyecatch from './img/eyecatch_pptx.png'
import logo from './img/logo-a2015.png'
import buildSettingPptx from "./lib/buildSettingPptx";

const PptxPage = (props) => {
  const [setting, setSetting] = useState(buildSettingPptx());
  const dispatch = useDispatch();

  const job = useSelector((state) => state.manual.job)
  const status = useSelector((state) => state.manual.status);
  const optional = useSelector((state) => state.manual.optional);

  const download = () => {
    if (! setting.pref) {
      alert('[STEP1] プルダウンにて「都道府県」を指定してください');
    } else {
      dispatch(registerJobAndWait(setting));
    }
  }

  document.title="気候変動情報スライド出力ツール | 適応事例・データ | 気候変動適応情報プラットフォーム（A-PLAT）"

  return (
    <>
      <div id="header">
        <div id="logo-aplat">
          <a href="https://adaptation-platform.nies.go.jp/index.html"><img src={alplat_logo} alt="A-PLAT" /></a>
        </div>
        <div id="logo-nies">
          <a href="https://www.nies.go.jp/"><img src={logo} alt="nies" /></a>
        </div>
      </div>
      <div id="description" className="pptx-bg">
        <div className="content">
          <h1>気候変動情報スライド出力ツール</h1>

          <div className="grid-container">
            <div class="grid-left">
              <p>
                本ツールは、地方公共団体ごとに気象観測データや将来の気候予測及び気候変動影響予測に関するグラフや図表を表示し、パワーポイント形式で出力するものです。気候変動に関する各種資料の作成時にご活用いただけます。
              </p>
              <p>
                関連ツールとして、A-PLATでは「<a href="https://adaptation-platform.nies.go.jp/local/plan/draft_generator_explanation.html">地域気候変動適応計画作成支援ツール</a>」および「<a href="https://adaptation-platform.nies.go.jp/webgis/index.html">気候変動の将来予測WebGIS</a>」もご利用いただけます。</p>
              <p>
                なお、データの利用に当たり、<a href="https://adaptation-platform.nies.go.jp/webgis/point.html">将来予測を利用される際の注意点</a>をご確認ください。
              </p>
            </div>
            <div class="grid-right">
              <img id="eyecatch" src={eyecatch} alt="eyecatch" />
            </div>
          </div>
        </div>
      </div>{/* description */}
      <div id="form">
        <div className="content">
          <div className="labelBox pptx-bg">
            <div className="step">STEP1</div>
            <div className="order">都道府県・市区町村を選択してください。</div>
          </div>
          <div className="formItem">
            <PrefMunicipalitySelect setting={setting} setSetting={setSetting} />
          </div>

          <div className="labelBox pptx-bg">
            <div className="box step">STEP2</div>
            <div className="box order">
              計画に含める指標を選択してください。
            </div>
          </div>
          <div className="formNote">
            <ul>
              <li>グラフ・画像は選択された自治体のものに差し変わります。</li>
              <li>チェックボックスにより、出力するデータをカスタマイズできます。</li>
            </ul>
          </div>
          <div className="formItem">
            <CheckAllInterface setting={setting} setSetting={setSetting} /> 
            <SettingInterfacePptx setting={setting} setSetting={setSetting} optional={optional} />
          </div>

          <div className="labelBox pptx-bg">
            <div className="box step">STEP3</div>
            <div className="box order">
              グラフ画像のフォントの大きさを選択して下さい。
            </div>
          </div>
          <div className="formItem">
            <FontSizeSelect setting={setting} setSetting={setSetting} />
          </div>

          <div className="labelBox pptx-bg">
            <div className="box step">STEP4</div>
            <div className="box order">
              上記で宜しければ、ダウンロードボタンを押してください。
            </div>
          </div>
          <div className="formItem">
            <form className="button" id="form">
              <button type="button" className="download-button" onClick={download}>ダウンロード</button>
            </form>
          </div>
        </div>
      </div>

      <div id="footer" >
        <div className="content">
          <div className="logos">
            <a href="http://ccca.nies.go.jp/ja/" target="_blank" rel="noreferrer"><img src={bnr_ccca} alt="国立環境研究所 気候変動適応センター" /></a>
            <a href="http://www.env.go.jp/" target="_blank" rel="noreferrer"><img src={bnr_env} alt="環境省" /></a>
          </div>
          <p className="version">version 1.0</p>
          <p className="browser">対応確認済みブラウザ: Google Chrome 139.0.7258.128, Firefox 141.0.3, Microsoft Edge 139.0.3405.86</p>
        </div>
      </div>
      <WaitWidget job={job} status={status} fileType="PowerPoint" />
    </>
  )
}

export default PptxPage;
